import React from "react"
import { Switch } from "react-router-dom"
import { PrivateRoute } from "../utils/PrivateRoute"
import NotFoundPage from "../components/NotFound"
import NewRequest from "../pages/NewRequest/NewRequest";
import RequestList from "../pages/RequestList/RequestList";
import RequestDetails from "../pages/RequestDetails/RequestDetails";
import { routePath } from "./paths"
import {DigitalFront} from "../pages/DigitalFront/DigitalFront";
import Verification from "../pages/Verification/Verification";


function Routes (props) {

    return (
        <Switch>
          <PrivateRoute
            path={routePath.HOME}
            exact
            component={Verification}
          />
          <PrivateRoute
            path={routePath.NEW_REQUEST}
            exact
            component={NewRequest}
          />
          <PrivateRoute
            path={routePath.REQUEST_LIST}
            exact
            component={RequestList}
          />
          <PrivateRoute
            path={routePath.REQUEST_DETAILS}
            exact
            component={RequestDetails}
          />
          <PrivateRoute
            path={routePath.DIGITAL_FRONT}
            component={DigitalFront}
          />
          <PrivateRoute
            path='*'
            permissions={[]}
            component={NotFoundPage}
          />
        </Switch>
    )
}

export default Routes

